import { render, staticRenderFns } from "./proofersSettings.vue?vue&type=template&id=0fdda499&scoped=true"
import script from "./proofersSettings.vue?vue&type=script&lang=js"
export * from "./proofersSettings.vue?vue&type=script&lang=js"
import style0 from "./proofersSettings.vue?vue&type=style&index=0&id=0fdda499&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdda499",
  null
  
)

export default component.exports